import moment              from "moment";
import CustomerSearchValue from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType    from "../../../domain/customer/criteria/CustomerSortType";
import Customer            from "../../../domain/customer/Customer";
import CustomerBirthDate   from "../../../domain/customer/CustomerBirthDate";
import CustomerBirthday    from "../../../domain/customer/CustomerBirthday";
import CustomerBirthMonth  from "../../../domain/customer/CustomerBirthMonth";
import CustomerBirthYear   from "../../../domain/customer/CustomerBirthYear";
import CustomerContact     from "../../../domain/customer/CustomerContact";
import CustomerDetail      from "../../../domain/customer/CustomerDetail";
import CustomerId          from "../../../domain/customer/CustomerId";
import CustomerNumber      from "../../../domain/customer/CustomerNumber";
import CustomerRepository  from "../../../domain/customer/CustomerRepository";
import Customers           from "../../../domain/customer/Customers";
import Address             from "../../../domain/fundamentals/address/Address";
import Building              from "../../../domain/fundamentals/address/Building";
import City                  from "../../../domain/fundamentals/address/City";
import PostalCode            from "../../../domain/fundamentals/address/PostalCode";
import Prefecture            from "../../../domain/fundamentals/address/Prefecture";
import Street                from "../../../domain/fundamentals/address/Street";
import Count                 from "../../../domain/fundamentals/count/Count";
import Email                 from "../../../domain/fundamentals/email/Email";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FirstName             from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana         from "../../../domain/fundamentals/name/FirstNameKana";
import LastName              from "../../../domain/fundamentals/name/LastName";
import LastNameKana          from "../../../domain/fundamentals/name/LastNameKana";
import Name                  from "../../../domain/fundamentals/name/Name";
import CurrentPage           from "../../../domain/fundamentals/pagination/CurrentPage";
import Pagination            from "../../../domain/fundamentals/pagination/Pagination";
import TotalPage             from "../../../domain/fundamentals/pagination/TotalPage";
import Phone                 from "../../../domain/fundamentals/phone/Phone";
import CreatedAt             from "../../../domain/fundamentals/trail/CreatedAt";
import Trail                 from "../../../domain/fundamentals/trail/Trail";
import UpdatedAt             from "../../../domain/fundamentals/trail/UpdatedAt";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import CustomerDataSource    from "../../../infrastructure/datasource/customer/CustomerDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";

class GetCustomers {
  constructor(
    private readonly dispatch,
    private readonly customerRepository: CustomerRepository = new CustomerDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public async execute(current: CurrentPage, search: CustomerSearchValue, sortType: CustomerSortType) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.customerRepository.findByPage(current, search, sortType);
      const list: Customer[] = response.data.customers.map(customer => (
        new Customer(
          new CustomerId(customer.id),
          new CustomerDetail(
            new CustomerNumber(customer.detail.number),
            new Name(
              new LastName(customer.detail.last_name),
              new FirstName(customer.detail.first_name),
              new LastNameKana(customer.detail.last_name_kana),
              new FirstNameKana(customer.detail.first_name_kana),
            ),
            customer.detail.gender_type,
          ),
          new CustomerBirthday(
            new CustomerBirthYear(customer.birthday.year),
            new CustomerBirthMonth(customer.birthday.month),
            new CustomerBirthDate(customer.birthday.date),
          ),
          new CustomerContact(
            new Phone(customer.contact.phone_number),
            new Email(customer.contact.email),
          ),
          new Address(
            new PostalCode(customer.address.postal_code),
            new Prefecture(customer.address.prefecture),
            new City(customer.address.city),
            new Street(customer.address.street),
            new Building(customer.address.building)
          ),
          new Trail(
            new CreatedAt(moment(customer.trail.created_at)),
            new UpdatedAt(moment(customer.trail.updated_at))
          )
        )
      ));

      const pagination: Pagination = new Pagination(new CurrentPage(response.data.pagination.current), new TotalPage(response.data.pagination.total));
      const count: Count = new Count(response.data.count);
      const customers: Customers = new Customers(list, pagination, count, search, sortType);
      this.customerRepository.setCustomers(customers);
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetCustomers;
